import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Flame } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[75vh] flex items-center pt-6 pb-8 overflow-hidden bg-dark" data-id="element-85">
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-accent-pink/20 rounded-full blur-[120px] pointer-events-none" data-id="element-86" />
      <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-accent-cyan/20 rounded-full blur-[120px] pointer-events-none" data-id="element-87" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-88">
        <div className="flex flex-col items-center text-center max-w-5xl mx-auto" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-pink/10 border border-accent-pink/30 text-accent-pink mb-4 font-semibold" data-id="element-90">
            <Flame className="w-5 h-5" data-id="element-91" />
            <span data-id="element-92">OFERTA POR TIEMPO LIMITADO</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-93">
            APRENDÉ SERIGRAFÍA DESDE CERO Y LOGRÁ ESTAMPAS{' '}
            <span className="text-gradient-primary" data-id="element-94">PROFESIONALES</span> EN
            MINUTOS
          </motion.h1>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.85
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative w-full max-w-xs mx-auto mb-6" data-id="element-95">
            <div className="absolute inset-0 bg-gradient-to-tr from-accent-cyan/30 via-accent-pink/30 to-accent-yellow/30 blur-[60px] rounded-full" data-id="element-96" />
            <motion.img animate={{
            y: [0, -12, 0]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} src="https://cdn.magicpatterns.com/uploads/mwiQsGXbTYiYGCZvg5ogzk/Kit_de_Cerigrafia_PRO.png" alt="Kit de Serigrafía PRO Mockup" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-97" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-xl md:text-2xl text-gray-300 mb-6 max-w-3xl mx-auto font-light" data-id="element-98">
            Sistema paso a paso para crear tus propios diseños o empezar a
            vender, incluso si nunca tocaste un bastidor.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} data-id="element-99">
            <CTAButton text="QUIERO EMPEZAR AHORA" data-id="element-100" />
          </motion.div>
        </div>
      </div>
    </section>;
}